/**
 * Swimmable JavaScript/TypeScript SDK
 * Official SDK for the Swimmable API - Real-time swimming conditions and water quality data
 * 
 * @example
 * ```typescript
 * import { SwimmableClient } from '@swimmable/sdk';
 * 
 * const client = new SwimmableClient({
 *   apiKey: 'your-api-key-here'
 * });
 * 
 * // Get basic conditions
 * const conditions = await client.getConditions({ lat: 34.0522, lon: -118.2437 });
 * console.log(`Water temperature: ${conditions.waterTemperature}°C`);
 * 
 * // Get enhanced conditions with safety scores
 * const enhanced = await client.getEnhancedConditions({ lat: 34.0522, lon: -118.2437 });
 * console.log(`Swimmability score: ${enhanced.swimmabilityScore}/10`);
 * ```
 */

// Export the main client class and factory function
export { SwimmableClient, createClient } from './client';

// Export all types for TypeScript users
export type {
  SwimmableConfig,
  Coordinates,
  BasicConditions,
  EnhancedConditions,
  SpotsResponse,
  SpotInfo,
  HealthStatus,
  UsageStats,
  ApiKeyInfo,
  CreateApiKeyRequest,
  CreateApiKeyResponse,
  RequestOptions,
} from './types';

// Export utilities and helpers
export {
  LocationUtils,
  ConditionsUtils,
  ApiKeyUtils,
  RateLimiter,
} from './utils';

// Export exceptions
export {
  SwimmableError,
  SwimmableAPIError,
  SwimmableTimeoutError,
  SwimmableValidationError,
  SwimmableAuthenticationError,
  SwimmableRateLimitError,
} from './exceptions';

// Version information
export const VERSION = '1.0.0';